class CompanyService {

    private static _companies: Array<Classes.Models.Company> = null;
    static get companies() {
        if (CompanyService._companies == null) {
            //CompanyService._companies = []; Avaliar concorrencia
            CompanyService.loadCompanies();
        }
        return CompanyService._companies;
    }

    static getCompany(id) {
        if (!id)
            return null;
        var company = CompanyService.companies.find(f => f.id === id);
        return company;
    }

    static getCompanyName(id) {
        var company = CompanyService.getCompany(id);
        return company ? company.name : "";
    }

    static loadCompanies() {
        let o = {
            url: urlConfigs.designer + "GetDataSourceCompanies",
            data: {},
            dataType: "json",
            async: false,
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            CompanyService._companies = createInstances(Classes.Models.Company, data.companies ?? []);
        }.bind(this);
        o.failureFunction = function (textStatus, failureText, errorItem: IError) {
            errorItem.userMessage = `Failed to get the companies`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, failureText);
        };

        irGlobal.requestServer(o);
    }
}